
export function errorMessageFromErrorObject(errorObject: any): string | any {
  if (!errorObject) {
    return errorObject;
  }
  try {
    if (errorObject?.response && errorObject.response.data) {
      return JSON.stringify(errorObject.response.data);
    }
    return errorObject && (errorObject.message || JSON.stringify(errorObject));
  } catch (err) {
    return 'failed to get error from original error object';
  }
}